// import { useState, useEffect } from "react";
// import MainLayouts from "../../../Layout/MainLayouts";
// import { ReactComponent as CheckSquareFill } from "bootstrap-icons/icons/check-square-fill.svg";
// import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
// import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import Spinner from "../../spinner/Spinner";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import Desk from "../../../assets/desk.png";
// import axios from "axios";
// import ApiServices from "../../../api/ApiServices";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import Swal from "sweetalert2";
// import CustomStyles from "../../../components/utils/CustomStyles";
// import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
// import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
// import AxiosApiCall from "../../../api/AxiosApiCall";

// const BranchSalesHistory = () => {
//   const [salesHistory, setSalesHistory] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [branch_id, setBranchId] = useState("");
//   const [branchName, setBranchName] = useState("");
//   const [filterText, setFilterText] = useState("");
//   const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//   const [confirmationLoading, setConfirmationLoading] = useState(false);

//   const navigate = useNavigate();
//   const location = useLocation();

//   const { mydata } = location.state || {};

//   useEffect(() => {
//     if (mydata) {
//       setBranchId(mydata.id);
//       setBranchName(mydata.name);
//     }
//   }, [mydata]);

//   //axios api encryption call
//   const axios = AxiosApiCall();

//   //format date
//   const formatDate = (dateString) => {
//     if (!dateString) {
//       return "Not Available";
//     }
//     const date = new Date(dateString);
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     const hours = String(date.getHours()).padStart(2, '0');
//     const minutes = String(date.getMinutes()).padStart(2, '0');
//     return `${year}-${month}-${day} ${hours}:${minutes}`;
//   };

//   useEffect(() => {
//     const fetchBranchSalesHistory = async () => {
//       const formData = {
//         branch_id: branch_id,
//       };

//       setLoading(true);
//       try {
//         const authData = JSON.parse(localStorage.getItem("auth"));
//         const token = authData?.token;
//         if (!token) {
//           throw new Error("No access token found.");
//         }

//         const response = await axios.get(`${ApiServices.getBranchSalesHistory}?branch_id=${branch_id}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         });

//         if (response.data.status === 200) {
//           setSalesHistory(response.data.data);
//         } else if (response.data.status === 300) {
//           toast.error(response.data.message);
//         } else if (response.data.status === 302) {
//           localStorage.removeItem("auth");
//           toast.error(response.data.message);
//           navigate("/");
//         } else if (response.data.status === 400) {
//           toast.error(response.data.message);
//           navigate("/salesHistory/list");
//         }
//       } catch (error) {
//         console.error("Error fetching sales history:", error.message);
//         toast.error("Error fetching sales history.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (branch_id) {
//       fetchBranchSalesHistory();
//     }
//   }, [branch_id]);

//   const handleFilter = (e) => {
//     setFilterText(e.target.value);
//     setResetPaginationToggle(!resetPaginationToggle);
//   };

//   const columns = [
//     {
//       name: "Invoice",
//       selector: (row) => row.sale.invoice_number,
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Customer",
//       selector: (row) => row.sale.customer_name.toUpperCase(),
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Date",
//       selector: (row) => formatDate(row.sale.sale_date),
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Products",
//       selector: (row) => row.items.map(item => item.product_name).join(", "),
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Total Amount",
//       selector: (row) => CurrencyFormatter(row.sale.total_amount),
//       sortable: true,
//       width: "150px",
//     },
//     {
//       name: "Status",
//       selector: (row) => row.sale.payment_status.toUpperCase(),
//       sortable: true,
//       width: "150px",
//       cell: (row) => (
//         <span className={`badge ${row.sale.payment_status === 'paid' ? 'bg-success' : 'bg-danger'}`}>
//           {row.sale.payment_status.toUpperCase()}
//         </span>
//       ),
//     },
//     {
//       name: "Actions",
//       cell: (row) => (
//         <div className="d-flex justify-content-end buttons">
//           <button
//             className="btn btn-info btn-sm"
//             onClick={() => {
//               navigate("/operations/branch/sales/details", {
//                 state: { saleData: row },
//               });
//             }}
//             style={{ marginLeft: "5px" }}
//             data-toggle="tooltip"
//             data-placement="bottom"
//             title="View sale details"
//           >
//             <Eye className="w-5 h-5 text-dash4 mr-3" />
//           </button>
//         </div>
//       ),
//       width: "150px",
//     },
//   ];

//   const filteredItems = salesHistory.filter((item) => {
//     const searchString = filterText.toLowerCase();
//     return (
//       item.sale.invoice_number.toLowerCase().includes(searchString) ||
//       item.sale.customer_name.toLowerCase().includes(searchString) ||
//       item.sale.payment_status.toLowerCase().includes(searchString) ||
//       item.items.some(product =>
//         product.product_name.toLowerCase().includes(searchString) ||
//         product.product_category.toLowerCase().includes(searchString)
//       )
//     );
//   });

//   return (
//     <div>
//       <MainLayouts>
//         <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//           <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
//             <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//               <ol className="list-none p-0 inline-flex mb-2">
//                 <li className="flex items-center">
//                   <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                     Operations
//                   </p>
//                   <ChevronRightIcon />
//                 </li>
//                 <li className="flex items-center">
//                   <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                     {branchName ? branchName : "Branch Sales History"}
//                   </p>
//                   <ChevronRightIcon />
//                 </li>
//                 <li className="flex items-center">
//                   <p className="text-orange1">Sales History</p>
//                 </li>
//               </ol>
//             </nav>
//           </section>

//           <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
//             <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
//               <input
//                 type="search"
//                 className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
//                 placeholder="Search by invoice, customer, product..."
//                 value={filterText}
//                 onChange={handleFilter}
//               />
//             </div>
//             <div className="pb-4 bg-white dark:bg-gray-900 flex justify-end">
//               <Link
//                 to="/operations/branch/customer"
//                 className="text-dGrey3 py-3 bg-darkGreen3 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center w-/4 my-0"
//               >
//                 <span className="flex mx-2">
//                   <List className="mr-2" />
//                   Back To Customer List
//                 </span>
//               </Link>
//             </div>
//           </div>
//           {loading ? (
//             <Spinner loading={loading} />
//           ) : (
//             <DataTable
//               columns={columns}
//               data={filteredItems}
//               pagination
//               striped
//               highlightOnHover
//               noDataComponent={<div>No sales history found</div>}
//               customStyles={CustomStyles}
//             />
//           )}
//         </div>
//       </MainLayouts>
//     </div>
//   );
// };

// export default BranchSalesHistory;

import { useState, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import AxiosApiCall from "../../../api/AxiosApiCall";
import ApiServices from "../../../api/ApiServices";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

const BranchSalesHistory = () => {
  const [salesHistory, setSalesHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [branch_id, setBranchId] = useState("");
  const [branchName, setBranchName] = useState("");
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const { mydata } = location.state || {};

  useEffect(() => {
    if (mydata) {
      setBranchId(mydata.id);
      setBranchName(mydata.name);
    }
  }, [mydata]);

  //axios api encryption call
  const axios = AxiosApiCall();

  //format date
  const formatDate = (dateString) => {
    if (!dateString) {
      return "Not Available";
    }
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  const fetchBranchSalesHistory = async (dateFilter = false) => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }

      // Build query parameters
      let queryParams = `branch_id=${branch_id}`;

      // if (dateFilter && startDate && endDate) {
      //   const formatDateForAPI = (date) => {
      //     return date.toISOString().split('T')[0]; // YYYY-MM-DD format
      //   };
      //   queryParams += `&start_date=${formatDateForAPI(startDate)}&end_date=${formatDateForAPI(endDate)}`;
      // }

      if (dateFilter && startDate && endDate) {
        // Convert the input string dates to Date objects
        const start = new Date(startDate);
        const end = new Date(endDate);
        // console.log("end date", end);
        // console.log("start date", start);

        // Format dates as YYYY-MM-DD
        const formatDateForAPI = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        queryParams += `&start_date=${formatDateForAPI(start)}&end_date=${formatDateForAPI(end)}`;
        // console.log("date parameter", queryParams);
      }

      const response = await axios.get(`${ApiServices.getBranchSalesHistory}?${queryParams}`, {
        // const response = await axios.get(`${ApiServices.getBranchSalesHistory}?branch_id=${branch_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      if (response.data.status === 200) {
        setSalesHistory(response.data.data);
      } else if (response.data.status === 300) {
        toast.error(response.data.message);
      } else if (response.data.status === 302) {
        localStorage.removeItem("auth");
        toast.error(response.data.message);
        navigate("/");
      } else if (response.data.status === 400) {
        toast.error(response.data.message);
        navigate("/salesHistory/list");
      }
    } catch (error) {
      // console.error("Error fetching sales history:", error.message);
      toast.error("Error fetching sales history.");
    } finally {
      setLoading(false);
    }
  };



  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  useEffect(() => {
    if (branch_id) {
      fetchBranchSalesHistory();
    }
  }, [branch_id]);

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const handleDateFilter = () => {
    if (startDate && endDate) {
      fetchBranchSalesHistory(true);
    } else {
      toast.warning("Please select both start and end dates");
    }
  };

  const handleClearDateFilter = () => {
    setStartDate(null);
    setEndDate(null);
    fetchBranchSalesHistory();
  };

  const columns = [
    {
      name: "Invoice",
      selector: (row) => row.sale.invoice_number,
      sortable: true,
      width: "200px",
    },
    {
      name: "Customer",
      selector: (row) => row.sale.customer_name.toUpperCase(),
      sortable: true,
      width: "200px",
    },
    {
      name: "Date",
      selector: (row) => formatDate(row.sale.sale_date),
      sortable: true,
      width: "200px",
    },
    {
      name: "Products",
      selector: (row) => row.items.map(item => item.product_name).join(", "),
      sortable: true,
      width: "200px",
    },
    {
      name: "Total Amount",
      selector: (row) => CurrencyFormatter(row.sale.total_amount),
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row.sale.payment_status.toUpperCase(),
      sortable: true,
      width: "150px",
      cell: (row) => (
        <span className={`badge ${row.sale.payment_status === 'paid' ? 'bg-success' : 'bg-danger'}`}>
          {row.sale.payment_status.toUpperCase()}
        </span>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex justify-content-end buttons">
          <button
            className="btn btn-info btn-sm"
            onClick={() => {
              navigate("/operations/branch/sales/details", {
                state: { saleData: row },
              });
            }}
            style={{ marginLeft: "5px" }}
            data-toggle="tooltip"
            data-placement="bottom"
            title="View sale details"
          >
            <Eye className="w-5 h-5 text-dash4 mr-3" />
          </button>
        </div>
      ),
      width: "150px",
    },
  ];

  const filteredItems = salesHistory.filter((item) => {
    const searchString = filterText.toLowerCase();
    return (
      item.sale.invoice_number.toLowerCase().includes(searchString) ||
      item.sale.customer_name.toLowerCase().includes(searchString) ||
      item.sale.payment_status.toLowerCase().includes(searchString) ||
      item.items.some(product =>
        product.product_name.toLowerCase().includes(searchString) ||
        product.product_category.toLowerCase().includes(searchString))
    );
  });

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Operations
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    {branchName ? branchName : "Branch Sales History"}
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">Sales History</p>
                </li>
              </ol>
            </nav>
          </section>

          <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Search by invoice, customer, product..."
                value={filterText}
                onChange={handleFilter}
              />
            </div>
            <div className="pb-4 bg-white dark:bg-gray-900 flex justify-end">
              <Link
                to="/operations/branch/list"
                className="text-dGrey3 py-3 bg-darkGreen3 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center w-/4 my-0"
              >
                <span className="flex mx-2">
                  <List className="mr-2" />
                  Back To Customer List
                </span>
              </Link>
            </div>
          </div>

          {/* Date Filter Section */}
          <div className="mb-4 p-4 bg-gray-50 rounded-lg shadow-sm">
            <h3 className="text-lg font-medium mb-3 text-gray-700">Filter by Date Range</h3>
            <div className="flex flex-wrap items-center gap-4">
              <div className="flex items-center">
                <label className="mr-2 text-sm font-medium text-gray-700">From:</label>
                <input
                  type="date"
                  value={startDate || ''}
                  onChange={handleStartDateChange}
                  className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="flex items-center">
                <label className="mr-2 text-sm font-medium text-gray-700">To:</label>
                <input
                  type="date"
                  value={endDate || ''}
                  onChange={handleEndDateChange}
                  min={startDate} // Ensure end date can't be before start date
                  className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <button
                onClick={handleDateFilter}
                className="px-4 py-2 bg-darkGreen3 text-lGrey rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                disabled={!startDate || !endDate}
              >
                Apply Filter
              </button>
              <button
                onClick={handleClearDateFilter}
                className="px-4 py-2 bg-orange1 text-lGrey rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
              >
                Clear
              </button>
            </div>
          </div>

          {loading ? (
            <Spinner loading={loading} />
          ) : (
            <DataTable
              columns={columns}
              data={filteredItems}
              pagination
              striped
              highlightOnHover
              noDataComponent={<div>No sales history found</div>}
              customStyles={CustomStyles}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default BranchSalesHistory;